import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Container, Grow } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ActionLinkHandler from './ActionLinkHandler';
import EmailActionHandler from './EmailActionHandler';

// Test page for previewing the Email Verification UI with adjustable states.
// Usage:
//   /app/test/verify-email?state=success
//   /app/test/verify-email?state=loading
//   /app/test/verify-email?state=error
//   /app/test/verify-email?state=message
const EmailVerificationTestPage = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get('state') || 'success';
  const view = searchParams.get('view') || 'handler';
  const message = searchParams.get('msg') || undefined;

  if (view === 'handler') {
    return (
      <Container maxWidth="sm" sx={{ pt: 4 }}>
        <Grow in timeout={300}>
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            <MarkEmailReadIcon color="primary" sx={{ fontSize: 80, mb: 2 }} />
            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{ fontWeight: 700, mb: 1 }}
            >
              Email Verification
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 520, mx: 'auto', mb: 2 }}>
              Preview the verification page layout and success states before deploying.
            </Typography>
          </Box>
        </Grow>

        <Box sx={{ mt: 0 }}>
        <ActionLinkHandler testMode={state} />
        </Box>
      </Container>
    );
  }

  // Full preview: header + simplified success/error UI (no box)
  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Grow in timeout={300}>
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <MarkEmailReadIcon color="primary" sx={{ fontSize: 80, mb: 2 }} />
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 700, mb: 1 }}
          >
            Email Verification
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 520, mx: 'auto', mb: 2 }}>
            Preview the verification page layout and success states before deploying.
          </Typography>
        </Box>
      </Grow>

      <Box sx={{ mt: 0 }}>
        <EmailActionHandler testMode={state} showTitle={false} />
      </Box>
    </Container>
  );
};

export default EmailVerificationTestPage;


